import { createAction, handleActions } from "redux-actions";
import { getCustomContentsAPI } from "@modules/apis/custom-contents";
import { GROUPING_VIEW_TYPE, LIST_VIEW_TYPE } from "@constants";

const initialState = {
    data: null,
    pending: false,
    error: false,
    isCardView: true,
    activeView: LIST_VIEW_TYPE.LIST,
    hierarchyType: GROUPING_VIEW_TYPE.FOLDER,
    create: {
        data: null,
        nextToken: null,
        pending: false,
        error: false,
    },
};

const GET_CUSTOM_CONTENTS_PENDING = "GET_CUSTOM_CONTENTS_PENDING";
const GET_CUSTOM_CONTENTS_SUCCESS = "GET_CUSTOM_CONTENTS_SUCCESS";
const GET_CUSTOM_CONTENTS_FAILURE = "GET_CUSTOM_CONTENTS_FAILURE";
const UPDATE_CUSTOM_CONTENTS_STATE = "UPDATE_CUSTOM_CONTENTS_STATE";
const RESET_CUSTOM_CONTENTS = "RESET_CUSTOM_CONTENTS";
const UPDATE_CUSTOM_CONTENTS_DATA = "UPDATE_CUSTOM_CONTENTS_DATA";

export default handleActions(
    {
        [GET_CUSTOM_CONTENTS_PENDING]: (state) => {
            return { ...state, data: null, pending: true, error: false };
        },
        [GET_CUSTOM_CONTENTS_SUCCESS]: (state, action) => {
            return { ...state, data: action.payload, pending: false };
        },
        [GET_CUSTOM_CONTENTS_FAILURE]: (state, action) => {
            return { ...state, data: null, pending: false, error: action.payload };
        },
        [UPDATE_CUSTOM_CONTENTS_STATE]: (state, action) => {
            return { ...state, activeView: action.payload.activeView, hierarchyType: action.payload.hierarchyType };
        },
        [RESET_CUSTOM_CONTENTS]: (state) => {
            return {
                ...initialState,
            };
        },
        [UPDATE_CUSTOM_CONTENTS_DATA]: (state, action) => {
            return {
                ...state,
                data: state.data.map((content) => {
                    if (content.id !== action.payload.id) return content;
                    return {
                        ...content,
                        [action.payload.type]: action.payload.value,
                    };
                }),
            };
        },
    },
    initialState,
);

export const updateCustomContentsState = createAction(UPDATE_CUSTOM_CONTENTS_STATE);
export const updateCustomContentsData = createAction(UPDATE_CUSTOM_CONTENTS_DATA);
export const resetCustomContents = createAction(RESET_CUSTOM_CONTENTS);

export const getCustomContents = (params) => async (dispatch, getState) => {
    const { stage, project } = getState();

    try {
        dispatch({
            type: GET_CUSTOM_CONTENTS_PENDING,
        });
        const { data } = await getCustomContentsAPI(stage.id, stage.endpoint, project.id, params);

        dispatch({
            type: GET_CUSTOM_CONTENTS_SUCCESS,
            payload: data?.results,
        });

        return data.nextToken;
    } catch (error) {
        dispatch({ type: GET_CUSTOM_CONTENTS_FAILURE, payload: error });
        throw error;
    }
};
